import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import Icon from '@/Components/Icon/Icon';
const IconButton = forwardRef(({ onClick, className = '', icon, title, focusable, iconClassName = '', disabled = false, ...rest }, ref) => {
    const click = (e) => {
        e.preventDefault();
        onClick(e);
    };
    const focusableClass = focusable ? '' : 'focus:shadow-none';
    return (_jsx("button", { ...rest, type: "button", title: title, className: `no-border flex cursor-pointer flex-row items-center bg-transparent ${focusableClass} ${className}`, onClick: click, disabled: disabled, "aria-label": title, ref: ref, children: _jsx(Icon, { type: icon, className: iconClassName }) }));
});
export default IconButton;
